
































  import { EnteteDemandesTableau } from '@/components/demandes/tableau/entete';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'DemandesTableauEnteteDesktop',
    mixins: [EnteteDemandesTableau],
    props: {
      filtreRecherche: {
        type: String,
        default: '',
      },
    },
  });
